export const leafletLang = {
    es: {
        draw: {
            toolbar: {
                actions: {
                    title: 'Cancelar zona',
                    text: 'Cancelar'
                },
                finish: {
                    title: 'Finalizar zona',
                    text: 'Final'
                },
                undo: {
                    title: 'Eliminar último punto dibujado',
                    text: 'Eliminar último punto'
                },
                buttons: {
                    polyline: 'Dibujar una línea',
                    polygon: 'Dibujar una zona',
                    rectangle: 'Dibujar un rectángulo',
                    circle: 'Dibujar un círculo',
                    marker: 'Dibujar un marcador',
                    circlemarker: 'Dibujar un marcador circular'
                }
            },
            handlers: {
                circle: {
                    tooltip: {
                        start: 'Haga clic y arrastre para dibujar un círculo.'
                    }
                },
                circlemarker: {
                    tooltip: {
                        start: 'Haga clic en el mapa para colocar un marcador circular.'
                    }
                },
                marker: {
                    tooltip: {
                        start: 'Haga clic en el mapa para colocar un marcador.'
                    }
                },
                polygon: {
                    tooltip: {
                        start: 'Haga clic para comenzar a dibujar una zona.',
                        cont: 'Haga clic para continuar dibujando la zona.',
                        end: 'Haga clic en el primer punto para cerrar esta zona.'
                    }
                },
                polyline: {
                    error: '<strong>Error:</strong> los bordes de la forma no pueden cruzarse.',
                    tooltip: {
                        start: 'Haga clic para comenzar a dibujar una linea.',
                        cont: 'Haga clic para continuar dibujando la línea.',
                        end: 'Haga clic en el último punto para finalizar la línea.'
                    }
                },
                rectangle: {
                    tooltip: {
                        start: 'Haga clic y arrastre para dibujar un rectángulo.'
                    }
                },
                simpleshape: {
                    tooltip: {
                        end: 'Suelte el ratón para finalizar el dibujo.'
                    }
                }
            }
        },
        edit: {
            toolbar: {
                actions: {
                    save: {
                        title: 'Guardar cambios',
                        text: 'Guardar'
                    },
                    cancel: {
                        title: 'Cancelar edición, descarta todos los cambios',
                        text: 'Cancelar'
                    },
                    clearAll: {
                        title: 'Borrar todas las zonas',
                        text: 'Borrar todo'
                    }
                },
                buttons: {
                    edit: 'Editar capas',
                    editDisabled: 'No hay capas para editar',
                    remove: 'Borrar capas',
                    removeDisabled: 'No hay capas para borrar'
                }
            },
            handlers: {
                edit: {
                    tooltip: {
                        text: 'Arrastre los manejadores o marcadores para editar.',
                        subtext: 'Haga clic en cancelar para deshacer los cambios.'
                    }
                },
                remove: {
                    tooltip: {
                        text: 'Haga clic en un elemento para eliminarlo'
                    }
                }
            }
        }
    },
    en: {
        draw: {
            toolbar: {
                actions: {
                    title: 'Cancel zone',
                    text: 'Cancel'
                },
                finish: {
                    title: 'Finish zone',
                    text: 'Finish'
                },
                undo: {
                    title: 'Delete last point drawn',
                    text: 'Delete last point'
                },
                buttons: {
                    polyline: 'Draw a polyline',
                    polygon: 'Draw a zone',
                    rectangle: 'Draw a rectangle',
                    circle: 'Draw a circle',
                    marker: 'Draw a marker',
                    circlemarker: 'Draw a circlemarker'
                }
            },
            handlers: {
                circle: {
                    tooltip: {
                        start: 'Click and drag to draw circle.'
                    }
                },
                circlemarker: {
                    tooltip: {
                        start: 'Click map to place circle marker.'
                    }
                },
                marker: {
                    tooltip: {
                        start: 'Click map to place marker.'
                    }
                },
                polygon: {
                    tooltip: {
                        start: 'Click to start drawing zone.',
                        cont: 'Click to continue drawing zone.',
                        end: 'Click first point to close this zone.'
                    }
                },
                polyline: {
                    error: '<strong>Error:</strong> shape edges cannot cross!',
                    tooltip: {
                        start: 'Click to start drawing line.',
                        cont: 'Click to continue drawing line.',
                        end: 'Click last point to finish line.'
                    }
                },
                rectangle: {
                    tooltip: {
                        start: 'Click and drag to draw rectangle.'
                    }
                },
                simpleshape: {
                    tooltip: {
                        end: 'Release mouse to finish drawing.'
                    }
                }
            }
        },
        edit: {
            toolbar: {
                actions: {
                    save: {
                        title: 'Save changes',
                        text: 'Save'
                    },
                    cancel: {
                        title: 'Cancel editing, discards all changes',
                        text: 'Cancel'
                    },
                    clearAll: {
                        title: 'Clear all layers',
                        text: 'Clear All'
                    }
                },
                buttons: {
                    edit: 'Edit layers',
                    editDisabled: 'No layers to edit',
                    remove: 'Delete layers',
                    removeDisabled: 'No layers to delete'
                }
            },
            handlers: {
                edit: {
                    tooltip: {
                        text: 'Drag handles, or marker to edit feature.',
                        subtext: 'Click cancel to undo changes.'
                    }
                },
                remove: {
                    tooltip: {
                        text: 'Click on a feature to remove'
                    }
                }
            }
        }
    }
};